/** A single value from a Vue Router `route.query` entry (may be repeated in the URL as an array). */
export type RouteQueryValue = string | null | undefined;

/** Vue Router location query object. */
export type RouteQuery = Record<string, RouteQueryValue | RouteQueryValue[]>;

/**
 * Normalizes a raw query value (string or string[]) to a trimmed string, or null if missing/invalid/blank.
 */
export function normalizeRouteQueryValue(raw: unknown): string | null {
  const first = Array.isArray(raw) ? raw[0] : raw;
  if (typeof first !== 'string') return null;
  const trimmed = first.trim();
  return trimmed || null;
}

/** Reads a single query parameter from a route query object. */
export function getRouteQueryParam(query: RouteQuery | undefined, paramName: string): string | null {
  if (!query) return null;
  return normalizeRouteQueryValue(query[paramName]);
}

/** Returns the value when it is one of the allowed strings; otherwise null. */
export function parseRouteQueryEnum<T extends string>(raw: unknown, validValues: ReadonlySet<string>): T | null {
  const value = normalizeRouteQueryValue(raw);
  if (!value || !validValues.has(value)) return null;
  return value as T;
}
